import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/cintillo/promo-abril/cintillo-desktop.png'
import _imports_1 from '@/assets/cintillo/promo-abril/cintillo-mobile.png'
import _imports_2 from '@/assets/images/app/logos-png.png'
import _imports_3 from '@/assets/images/app/somospartede.png'
import _imports_4 from '@/assets/images/app/interbank.png'
import _imports_5 from '@/assets/images/app/interseguro.png'
import _imports_6 from '@/assets/images/app/Frame.png'
import _imports_7 from '@/assets/images/app/plazavea.png'
import _imports_8 from '@/assets/images/app/financieraoh.png'
import _imports_9 from '@/assets/images/app/promart.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "home__head" }
const _hoisted_3 = {
  class: "navbar navbar-expand-lg",
  style: {"position":"fixed","top":"0","width":"100%","z-index":"1000","background-color":"#fff","padding":"0","box-shadow":"0px 4px 16px 0px rgba(69, 74, 108, 0.08) !important"}
}
const _hoisted_4 = { class: "container" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  class: "navbar-toggler",
  type: "button"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  class: "navbar-nav ms-auto",
  style: {"z-index":"1000"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: '#faq',
    class: "nav-link-questions"
  }, "Preguntas Frecuentes")
], -1)
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "carousel-content hidden-mobile" }
const _hoisted_12 = { class: "carousel-content__form" }
const _hoisted_13 = { class: "home__quote-card card-slider w-50" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "cuadro d-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "desde" }, "desde "),
  /*#__PURE__*/_createElementVNode("span", { class: "quantity" }, " S/160")
], -1)
const _hoisted_15 = { action: "#" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-start" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "pb-4 pt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"16px","color":"#454a6c","text-align":"left"} }, " ¿Quieres probar cuánto ganarías con Rumbo? ")
], -1)
const _hoisted_18 = ["minlength", "maxlength"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Al cotizar acepto la "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://documentos.interseguro.com.pe/PDF/PoliticaPrivacidadInterseguro-1810.pdf",
      target: "_blank"
    }, "política de privacidad")
  ])
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "home__banner__carousel__slider3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "home__banner__carousel__slider3__text" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ahorro" }, "Ahorra todos los meses"),
    /*#__PURE__*/_createElementVNode("h6", {
      class: "maestria mb-0",
      style: {"margin-bottom":"-2px"}
    }, " para tu DEPA "),
    /*#__PURE__*/_createElementVNode("span", { class: "hasta" }, "hasta"),
    /*#__PURE__*/_createElementVNode("div", {
      class: "d-flex align-items-center",
      style: {"margin-top":"-16px"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "number" }, "8.1"),
      /*#__PURE__*/_createElementVNode("span", { class: "porcent pt-3" }, "%"),
      /*#__PURE__*/_createElementVNode("span", { class: "trea pt-3" }, "TREA")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "home__banner__carousel__slider3__promo" })
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "home__banner__carousel__slider2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "home__banner__carousel__slider2__text" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ahorro" }, "Ahorra todos los meses"),
    /*#__PURE__*/_createElementVNode("h6", {
      class: "maestria",
      style: {"margin-bottom":"-2px"}
    }, " para tu NEGOCIO propio "),
    /*#__PURE__*/_createElementVNode("span", { class: "hasta" }, "hasta"),
    /*#__PURE__*/_createElementVNode("div", {
      class: "d-flex align-items-center",
      style: {"margin-top":"-16px"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "number" }, "8.1"),
      /*#__PURE__*/_createElementVNode("span", { class: "porcent pt-3" }, "%"),
      /*#__PURE__*/_createElementVNode("span", { class: "trea pt-3" }, "TREA")
    ])
  ])
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "home__banner__carousel__slider1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "home__banner__carousel__slider1__text" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ahorro" }, "Ahorra todos los meses"),
    /*#__PURE__*/_createElementVNode("h6", {
      class: "maestria",
      style: {"margin-bottom":"-2px"}
    }, " para tu MAESTRÍA "),
    /*#__PURE__*/_createElementVNode("span", { class: "hasta" }, "hasta"),
    /*#__PURE__*/_createElementVNode("div", {
      class: "d-flex align-items-center",
      style: {"margin-top":"-16px"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "number" }, "8.1"),
      /*#__PURE__*/_createElementVNode("span", { class: "porcent pt-3" }, "%"),
      /*#__PURE__*/_createElementVNode("span", { class: "trea pt-3" }, "TREA")
    ])
  ])
], -1)
const _hoisted_28 = {
  class: "carousel-content-mobile visible-mobile",
  style: {"padding-top":"60px"}
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "home__banner__newBanner visible-mobile" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "home__banner__newBanner__text" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ahorro" }, "Ahorra todos los meses"),
      /*#__PURE__*/_createElementVNode("h6", { class: "maestria mb-0" }, "para tu DEPA"),
      /*#__PURE__*/_createElementVNode("span", { class: "hasta1" }, "hasta"),
      /*#__PURE__*/_createElementVNode("div", { class: "home__banner__newBanner__text__content-trea-depa d-flex" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "number" }, "8.1%"),
        /*#__PURE__*/_createElementVNode("span", { class: "trea pt-3" }, "TREA")
      ])
    ])
  ])
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "home__banner__newBanner2 visible-mobile" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "home__banner__newBanner2__text" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ahorro" }, "Ahorra todos los meses"),
      /*#__PURE__*/_createElementVNode("h6", { class: "maestria mb-0" }, "para tu NEGOCIO"),
      /*#__PURE__*/_createElementVNode("h6", { class: "maestria mb-0" }, "propio"),
      /*#__PURE__*/_createElementVNode("span", { class: "hasta" }, "hasta"),
      /*#__PURE__*/_createElementVNode("div", { class: "home__banner__newBanner2__text__content-trea d-flex" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "number" }, "8.1%"),
        /*#__PURE__*/_createElementVNode("span", { class: "trea pt-3" }, "TREA")
      ])
    ])
  ])
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "home__banner__newBanner3 visible-mobile" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "home__banner__newBanner3__text" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "ahorro" }, "Ahorra todos los meses"),
      /*#__PURE__*/_createElementVNode("h6", { class: "maestria mb-0" }, "para tu MAESTRÍA"),
      /*#__PURE__*/_createElementVNode("span", { class: "hasta2" }, "hasta"),
      /*#__PURE__*/_createElementVNode("div", { class: "home__banner__newBanner3__text__content-trea-maestria d-flex" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "number" }, "8.1%"),
        /*#__PURE__*/_createElementVNode("span", { class: "trea pt-3" }, "TREA")
      ])
    ])
  ])
], -1)
const _hoisted_32 = { class: "container" }
const _hoisted_33 = { class: "home__quote-card" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "cuadro d-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "desde" }, "desde "),
  /*#__PURE__*/_createElementVNode("span", { class: "quantity" }, " S/160")
], -1)
const _hoisted_35 = { action: "#" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "pb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"16px","color":"#454a6c","text-align":"left"} }, " ¿Quieres probar cuánto ganarías con Rumbo? ")
], -1)
const _hoisted_37 = ["minlength", "maxlength"]
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Al cotizar acepto la "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://documentos.interseguro.com.pe/PDF/PoliticaPrivacidadInterseguro-1810.pdf",
      target: "_blank"
    }, "política de privacidad")
  ])
], -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "custom-cintillo-background" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "custom-cintillo-container" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "custom-cintillo" }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "custom-cintillo__cintillo custom-cintillo--desktop",
        src: _imports_0,
        alt: "cintillo-desktop"
      }),
      /*#__PURE__*/_createElementVNode("img", {
        class: "custom-cintillo__cintillo custom-cintillo--mobile",
        src: _imports_1,
        alt: "cintillo-mobile"
      })
    ])
  ])
], -1)
const _hoisted_45 = { class: "home__section-benefits" }
const _hoisted_46 = { class: "container" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h2", { style: {"padding":"35px 0px 40px 0px !important"} }, " Ahorra sin miedos y con la libertad que tú pediste ", -1)
const _hoisted_48 = { class: "row" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-5" }, null, -1)
const _hoisted_50 = { class: "col-sm" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "col-sm" }
const _hoisted_53 = { class: "home__section-benefits__benefit" }
const _hoisted_54 = { class: "benefit-img" }
const _hoisted_55 = ["src"]
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", null, "Congela tu cuenta por un tiempo si no puedes continuar con tu aporte", -1)
const _hoisted_57 = { class: "col-sm" }
const _hoisted_58 = { class: "home__section-benefits__benefit" }
const _hoisted_59 = { class: "benefit-img" }
const _hoisted_60 = ["src"]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", null, "Adquiere más de un plan en simultáneo", -1)
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-sm" }
const _hoisted_64 = { class: "home__section-benefits__benefit" }
const _hoisted_65 = { class: "benefit-img" }
const _hoisted_66 = ["src"]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", null, "Sube o baja tu monto de ahorro mensual", -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center w-100" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#startQuote",
    class: "home__section-benefits__btn"
  }, "¡Lo quiero!")
], -1)
const _hoisted_69 = { class: "home__section-benefits__title mt-5" }
const _hoisted_70 = ["src"]
const _hoisted_71 = /*#__PURE__*/_createElementVNode("span", null, "En caso de fallecimiento, cuentas con un seguro de vida por S/25,000", -1)
const _hoisted_72 = {
  class: "home__section-savings",
  id: "savings"
}
const _hoisted_73 = { class: "container" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode(" Conoce cómo María ahorra para "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" cumplir su meta y proteger a los que ama ")
], -1)
const _hoisted_75 = { class: "home__section-savings__image" }
const _hoisted_76 = ["src"]
const _hoisted_77 = ["src"]
const _hoisted_78 = ["href"]
const _hoisted_79 = { class: "custom-folleto-background" }
const _hoisted_80 = { class: "custom-cintillo-container" }
const _hoisted_81 = { class: "custom-cintillo" }
const _hoisted_82 = ["src"]
const _hoisted_83 = ["src"]
const _hoisted_84 = /*#__PURE__*/_createStaticVNode("<div class=\"hidden-mobile\"><div class=\"mb-5 mt-5\"><img src=\"" + _imports_2 + "\" alt=\"\" class=\"w-100\"></div></div><div class=\"visible-mobile\"><div class=\"somosParteDe\"><div class=\"somosParteDe__logo\"><img src=\"" + _imports_3 + "\" alt=\"\"></div></div><div class=\"Logos\"><div class=\"Logos__content\"><div class=\"interbank\"><img src=\"" + _imports_4 + "\" alt=\"\"></div></div><div class=\"Logos__content\"><div class=\"interseguro\"><img src=\"" + _imports_5 + "\" alt=\"\"></div></div><div class=\"Logos__content\"><div class=\"frame\"><img src=\"" + _imports_6 + "\" alt=\"\"></div></div><div class=\"Logos__content\"><div class=\"plazavea\"><img src=\"" + _imports_7 + "\" alt=\"\"></div></div><div class=\"Logos__content\"><div class=\"financieraoh\"><img src=\"" + _imports_8 + "\" alt=\"\"></div></div><div class=\"Logos__content\"><div class=\"promart\"><img src=\"" + _imports_9 + "\" alt=\"\"></div></div></div></div>", 2)
const _hoisted_86 = { class: "home__section-quote" }
const _hoisted_87 = { class: "container" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("h2", null, "Cotiza y compra en segundos", -1)
const _hoisted_89 = { class: "row" }
const _hoisted_90 = { class: "col-sm-5" }
const _hoisted_91 = { class: "home__section-quote__steps" }
const _hoisted_92 = { class: "home__section-quote__steps__img" }
const _hoisted_93 = ["src"]
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", { class: "home__section-quote__steps__text" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Paso 1"),
  /*#__PURE__*/_createElementVNode("p", null, "Ingresa tu DNI")
], -1)
const _hoisted_95 = { class: "home__section-quote__steps__img" }
const _hoisted_96 = ["src"]
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "home__section-quote__steps__text" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Paso 2"),
  /*#__PURE__*/_createElementVNode("p", null, "Llena tus datos")
], -1)
const _hoisted_98 = { class: "home__section-quote__steps__img" }
const _hoisted_99 = ["src"]
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "home__section-quote__steps__text" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Paso 3"),
  /*#__PURE__*/_createElementVNode("p", null, "Elige cuánto ahorrar y por cuánto tiempo")
], -1)
const _hoisted_101 = { class: "home__section-quote__steps__img" }
const _hoisted_102 = ["src"]
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", { class: "home__section-quote__steps__text" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Paso 4"),
  /*#__PURE__*/_createElementVNode("p", null, "Confirma tu compra")
], -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("span", { class: "home__section-quote__note" }, "¡Listo, ya estás haciendo crecer tu dinero!", -1)
const _hoisted_105 = { class: "col-sm d-flex justify-content-center" }
const _hoisted_106 = { class: "home__section-quote__gif" }
const _hoisted_107 = ["src"]
const _hoisted_108 = { class: "home__banner-sorteo hidden-mobile" }
const _hoisted_109 = {
  href: "https://www.interseguro.pe/vivemas/beneficios?product=rumbo",
  target: "_blank"
}
const _hoisted_110 = { class: "contenedor" }
const _hoisted_111 = ["src"]
const _hoisted_112 = { class: "home__banner-sorteo visible-mobile" }
const _hoisted_113 = {
  href: "https://www.interseguro.pe/vivemas/beneficios?product=rumbo",
  target: "_blank"
}
const _hoisted_114 = { class: "contenedor" }
const _hoisted_115 = ["src"]
const _hoisted_116 = {
  class: "home__section-feedback",
  id: "testimonials"
}
const _hoisted_117 = { class: "container" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("h2", null, "¡Ellos ya protegen a quienes más aman!", -1)
const _hoisted_119 = { class: "home__section-feedback__card" }
const _hoisted_120 = { class: "home__section-feedback__card__head" }
const _hoisted_121 = ["src"]
const _hoisted_122 = /*#__PURE__*/_createElementVNode("div", { class: "home__section-feedback__card__body" }, [
  /*#__PURE__*/_createElementVNode("span", null, " “Empezar a ahorrar con Rumbo fue muy fácil, a diferencia de otras aseguradoras. Además, lo pude hacer sola sin trámites complicados”. ")
], -1)
const _hoisted_123 = /*#__PURE__*/_createElementVNode("div", { class: "home__section-feedback__card__footer" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Ivana "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Arequipa, Peru ")
  ])
], -1)
const _hoisted_124 = { class: "home__section-feedback__card" }
const _hoisted_125 = { class: "home__section-feedback__card__head" }
const _hoisted_126 = ["src"]
const _hoisted_127 = /*#__PURE__*/_createElementVNode("div", { class: "home__section-feedback__card__body" }, [
  /*#__PURE__*/_createElementVNode("span", null, " “Lo interesante de Rumbo es que es digital y fácil de usar, lo puedo hacer desde mi casa”. ")
], -1)
const _hoisted_128 = /*#__PURE__*/_createElementVNode("div", { class: "home__section-feedback__card__footer" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" David "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Lima, Peru ")
  ])
], -1)
const _hoisted_129 = { class: "home__section-feedback__card" }
const _hoisted_130 = { class: "home__section-feedback__card__head" }
const _hoisted_131 = ["src"]
const _hoisted_132 = /*#__PURE__*/_createElementVNode("div", { class: "home__section-feedback__card__body" }, [
  /*#__PURE__*/_createElementVNode("span", null, " “Me gusta que pueda reducir mis aportes o congelar mi plan ante cualquier emergencia”. ")
], -1)
const _hoisted_133 = /*#__PURE__*/_createElementVNode("div", { class: "home__section-feedback__card__footer" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Johana "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Piura, Peru ")
  ])
], -1)
const _hoisted_134 = {
  class: "home__section-faq",
  id: "faq"
}
const _hoisted_135 = /*#__PURE__*/_createElementVNode("h2", null, "Preguntas frecuentes", -1)
const _hoisted_136 = { class: "container" }
const _hoisted_137 = { class: "home__section-faq__list" }
const _hoisted_138 = ["onClick"]
const _hoisted_139 = { class: "home__section-subscribe" }
const _hoisted_140 = { class: "container" }
const _hoisted_141 = ["disabled"]
const _hoisted_142 = { key: 0 }
const _hoisted_143 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_144 = {
  key: 0,
  class: "home__section-subscribe__success"
}
const _hoisted_145 = /*#__PURE__*/_createElementVNode("span", null, "Gracias. Nos pondremos en contacto contigo a la brevedad!", -1)
const _hoisted_146 = [
  _hoisted_145
]
const _hoisted_147 = ["href"]
const _hoisted_148 = ["src"]
const _hoisted_149 = ["href"]
const _hoisted_150 = ["src"]
const _hoisted_151 = ["src"]
const _hoisted_152 = /*#__PURE__*/_createElementVNode("div", { class: "chat-button__label visible-mobile" }, " Llámanos ", -1)
const _hoisted_153 = /*#__PURE__*/_createElementVNode("div", { class: "chat-button__label hidden-mobile" }, " Llámanos al (01) 614-9288 ", -1)
const _hoisted_154 = ["src"]
const _hoisted_155 = /*#__PURE__*/_createElementVNode("div", { class: "chat-button__label" }, " Comunícate con un asesor vía WhatsApp ", -1)
const _hoisted_156 = { class: "home__footer" }
const _hoisted_157 = { class: "container" }
const _hoisted_158 = { class: "row" }
const _hoisted_159 = /*#__PURE__*/_createStaticVNode("<div class=\"col-sm-8\"><div class=\"home__footer__RUC\"><div class=\"hidden-mobile\"><p>RUC 20382748566</p><p>INTERSEGURO COMPAÑIA DE SEGUROS S. A. </p></div></div><div class=\"home__footer__RUC\"><div class=\"visible-mobile\"><label>RUC 20382748566</label><label>INTERSEGURO COMPAÑIA DE SEGUROS S. A.</label></div></div></div>", 1)
const _hoisted_160 = { class: "col-sm-4" }
const _hoisted_161 = { class: "home__footer__logo" }
const _hoisted_162 = { class: "hidden-mobile" }
const _hoisted_163 = ["src"]
const _hoisted_164 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_165 = { class: "container" }
const _hoisted_166 = { class: "row" }
const _hoisted_167 = { class: "col-sm-8" }
const _hoisted_168 = { class: "home__footer__section" }
const _hoisted_169 = /*#__PURE__*/_createElementVNode("a", {
  class: "col-xs-12 col-sm-12 col-md-6",
  href: "https://drive.google.com/file/d/1Iee2iwNq7gmq_KHPPIqoHScz9vTh0rPw/view?usp=sharing",
  target: "_blank"
}, " Condicionado General ", -1)
const _hoisted_170 = /*#__PURE__*/_createElementVNode("a", {
  class: "col-xs-12 col-sm-12 col-md-6",
  href: "https://drive.google.com/file/d/169z7Wg8ipBG5Itc2ZJlUmVNAiAq36kIt/view?usp=sharing",
  target: "_blank"
}, " Condicionado Particular ", -1)
const _hoisted_171 = /*#__PURE__*/_createElementVNode("a", {
  class: "col-xs-12 col-sm-12 col-md-6",
  href: "mailto:rumbo@interseguro.com.pe"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "rumbo@interseguro.com.pe")
], -1)
const _hoisted_172 = { class: "col-sm-4" }
const _hoisted_173 = { class: "home__footer__logo" }
const _hoisted_174 = { class: "hidden-mobile" }
const _hoisted_175 = {
  href: "https://app.interseguro.com.pe/LibroReclamaciones/",
  target: "_blank"
}
const _hoisted_176 = ["src"]
const _hoisted_177 = { class: "home__footer__logo" }
const _hoisted_178 = { class: "visible-mobile" }
const _hoisted_179 = {
  href: "https://app.interseguro.com.pe/LibroReclamaciones/",
  target: "_blank"
}
const _hoisted_180 = ["src"]
const _hoisted_181 = { class: "quote-card" }
const _hoisted_182 = { class: "d-flex justify-content-start" }
const _hoisted_183 = { class: "form-group type-radio" }
const _hoisted_184 = /*#__PURE__*/_createElementVNode("label", { for: "client-dni" }, "DNI", -1)
const _hoisted_185 = { class: "form-group type-radio" }
const _hoisted_186 = /*#__PURE__*/_createElementVNode("label", { for: "client-ce" }, "CE", -1)
const _hoisted_187 = { key: 0 }
const _hoisted_188 = { class: "form-group" }
const _hoisted_189 = ["disabled"]
const _hoisted_190 = { key: 0 }
const _hoisted_191 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_192 = { class: "form-group" }
const _hoisted_193 = {
  label: "",
  for: "",
  style: {"position":"initial"}
}
const _hoisted_194 = { key: 0 }
const _hoisted_195 = { class: "form-group" }
const _hoisted_196 = ["disabled"]
const _hoisted_197 = { key: 0 }
const _hoisted_198 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_199 = /*#__PURE__*/_createElementVNode("div", { class: "modal-no-insurance__head" }, [
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createTextVNode(" ¡Ya cuentas con un seguro "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" de vida con devolucion! ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "Para más información puedes comunicarte con nuestro WhatsApp")
], -1)
const _hoisted_200 = { class: "d-flex justify-content-center" }
const _hoisted_201 = /*#__PURE__*/_createElementVNode("div", { class: "cookies__head" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "cookies__head__title" }, "Configuración de cookies"),
  /*#__PURE__*/_createElementVNode("p", null, " Este sitio web utiliza cookies para mejorar tu experiencia de navegación y para mostrarte publicidad relevante. Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo cuando visitas un sitio web. "),
  /*#__PURE__*/_createElementVNode("p", null, " Estos archivos permiten entender el comportamiento del usuario en la web, recordar detalles de acceso y preferencias de navegación. Sin embargo, el bloqueo de algunas cookies puede afectar la experiencia del usuario en el sitio web y los servicios ofrecidos. "),
  /*#__PURE__*/_createElementVNode("p", null, " Esta sección explica cómo se utilizan los diferentes tipos de cookies para asegurar el correcto funcionamiento de los servicios, mejorar la experiencia del usuario y analizar los datos. "),
  /*#__PURE__*/_createElementVNode("span", { class: "cookies__head__title" }, "Cookies Obligatorias"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", null, "NECESARIAS:"),
    /*#__PURE__*/_createTextVNode(" Estas cookies son esenciales para que el sitio web funcione y también protegen nuestro sitio web de posibles ataques cibernéticos y actividades fraudulentas. ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " Con estas también nos aseguramos que se cumpla la ley de protección de datos personales. Le informamos de que puede configurar su navegador para bloquear o alertar sobre estas cookies, sin embargo, es posible que determinadas áreas de la página web no funcionen. Estas cookies no almacenan ninguna información de identificación personal. "),
  /*#__PURE__*/_createElementVNode("span", { class: "cookies__head__title" }, "Cookies Opcionales"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", null, "ANALÍTICAS:"),
    /*#__PURE__*/_createTextVNode(" Estas cookies se utilizan para averiguar cómo los usuarios están usando nuestro sitio. Esto nos ayuda a corregir áreas que pueden no estar funcionando y hacer que el sitio sea más fácil de navegar. Además, con la intención de verificar si los cambios que hacemos en el sitio web lo hacen mejor o peor para usted. ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", null, "MARKETING:"),
    /*#__PURE__*/_createTextVNode(" Estas cookies recuerdan los productos que le interesan para mostrarle otros productos u ofertas que pueden ser relevantes cuando visita otros sitios web. ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " También se utilizan para asegurarnos de que no le mostremos anuncios de cosas que ya ha comprado y averiguar si nuestro marketing tuvo éxito. Las cookies publicitarias recopilan y guardan información sobre qué páginas visita, en qué hace clic y si compra un producto. Si elige no aceptar, seguirá viendo anuncios mientras navega por la web, pero no serán tan relevantes para sus intereses personales. ")
], -1)
const _hoisted_202 = { class: "hidden-mobile" }
const _hoisted_203 = { class: "cookies-buttons d-flex justify-content-center" }
const _hoisted_204 = { class: "cookies__btn-config" }
const _hoisted_205 = { class: "cookies__btn-aceptar" }
const _hoisted_206 = { class: "visible-mobile" }
const _hoisted_207 = { class: "cookies__btn-config" }
const _hoisted_208 = { class: "cookies__btn-aceptar" }
const _hoisted_209 = { class: "general-conditions" }
const _hoisted_210 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Usted puede brindar su consentimiento para que INTERSEGURO, las "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.interseguro.pe/soat/archivo/Pol%C3%ADtica_de_Privacidad_de_Interseguro-Anexo_1.pdf",
    target: "_blank"
  }, "empresas del Grupo Intercorp y/o sus socios comerciales:")
], -1)
const _hoisted_211 = { class: "custom-control custom-checkbox" }
const _hoisted_212 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "chkbxPolicies1"
}, "Realicen estudios de mercado y perfiles de compra. ", -1)
const _hoisted_213 = { class: "custom-control custom-checkbox" }
const _hoisted_214 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "chkbxPolicies2"
}, "Envíen publicidad, promociones y ofertas de los productos y/o servicios. ", -1)
const _hoisted_215 = { class: "custom-control custom-checkbox" }
const _hoisted_216 = ["checked"]
const _hoisted_217 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "chkbxPolicies3"
}, "Sí a todo. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_collapse = _resolveComponent("b-collapse")!
  const _component_carousel = _resolveComponent("carousel")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_b_card_text = _resolveComponent("b-card-text")!
  const _directive_b_toggle = _resolveDirective("b-toggle")!
  const _directive_b_modal = _resolveDirective("b-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: { name: 'home' },
            class: "navbar-brand"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                style: {"width":"220px","height":"auto"},
                src: require('@/assets/images/app/logos-Inter.png'),
                loading: "lazy",
                alt: ""
              }, null, 8, _hoisted_5)
            ]),
            _: 1
          }),
          _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_6, [
            _createElementVNode("img", {
              src: require('@/assets/images/app/Menu.png'),
              alt: ""
            }, null, 8, _hoisted_7)
          ])), [
            [
              _directive_b_toggle,
              void 0,
              void 0,
              { "nav-head": true }
            ]
          ]),
          _createVNode(_component_b_collapse, {
            class: "collapse navbar-collapse",
            id: "nav-head"
          }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("li", _hoisted_10, [
                  _withDirectives((_openBlock(), _createElementBlock("a", {
                    href: "#",
                    class: "nav-link nav-btn",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveLoginEvent())),
                    style: {"padding":"5px 9px 5px 9px"}
                  }, [
                    _createTextVNode("Zona cliente")
                  ])), [
                    [
                      _directive_b_modal,
                      void 0,
                      void 0,
                      { "login-modal": true }
                    ]
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("form", _hoisted_15, [
            _hoisted_16,
            _hoisted_17,
            _createElementVNode("div", {
              class: _normalizeClass(["form-group d-block", {
              invalid:
                this.v$.userInfo.identificationNumber.$error &&
                _ctx.flags.showError,
            }])
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "Ingresa tu DNI/CE",
                class: "form-control input-place",
                style: {"text-align":"center !important","border":"1px solid var(--neutral-color-medium, #a1a5c4)"},
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.v$.userInfo.identificationNumber.$model) = $event)),
                minlength: _ctx.documentLength,
                maxlength: _ctx.documentLength,
                onKeypress: _cache[2] || (_cache[2] = ($event: any) => (_ctx.validateInput($event))),
                onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.redirectToQuote())),
                onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.flags.showError = true))
              }, null, 40, _hoisted_18), [
                [_vModelText, this.v$.userInfo.identificationNumber.$model]
              ]),
              (this.v$.userInfo.identificationNumber.$error &&
                _ctx.flags.showError
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("span", {
                      class: _normalizeClass({
                  error: this.v$.userInfo.identificationNumber.$error,
                })
                    }, "Ingrese un número de documento válido", 2)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                type: "submit",
                class: "form-btn",
                disabled: _ctx.flags.searching
              }, [
                (!_ctx.flags.searching)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, "COTIZAR AHORA"))
                  : _createCommentVNode("", true),
                (_ctx.flags.searching)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_23))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_21)
            ]),
            _hoisted_24
          ])
        ])
      ]),
      _createVNode(_component_carousel, {
        margin: 0,
        dots: false,
        nav: true,
        items: 1,
        loop: true,
        autoplay: true,
        "autoplay-timeout": 6000,
        class: "home__banner__carousel"
      }, {
        default: _withCtx(() => [
          _hoisted_25,
          _hoisted_26,
          _hoisted_27
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createVNode(_component_carousel, {
        margin: 0,
        dots: false,
        nav: false,
        items: 1,
        loop: true,
        autoplay: true,
        "autoplay-timeout": 6000,
        class: "home__banner__carousel"
      }, {
        default: _withCtx(() => [
          _hoisted_29,
          _hoisted_30,
          _hoisted_31
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("form", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("div", {
              class: _normalizeClass(["form-group d-block", {
              invalid:
                this.v$.userInfo.identificationNumber.$error &&
                _ctx.flags.showError,
            }])
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "Ingresa tu DNI/CE",
                class: "form-control input-place",
                style: {"text-align":"center !important","border":"1px solid var(--neutral-color-medium, #a1a5c4)"},
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((this.v$.userInfo.identificationNumber.$model) = $event)),
                minlength: _ctx.documentLength,
                maxlength: _ctx.documentLength,
                onKeypress: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validateInput($event))),
                onKeyup: _cache[7] || (_cache[7] = ($event: any) => (_ctx.redirectToQuote())),
                onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.flags.showError = true))
              }, null, 40, _hoisted_37), [
                [_vModelText, this.v$.userInfo.identificationNumber.$model]
              ]),
              (this.v$.userInfo.identificationNumber.$error &&
                _ctx.flags.showError
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createElementVNode("span", {
                      class: _normalizeClass({
                  error: this.v$.userInfo.identificationNumber.$error,
                })
                    }, "Ingrese un número de documento válido", 2)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("button", {
                type: "submit",
                class: "form-btn",
                disabled: _ctx.flags.searching
              }, [
                (!_ctx.flags.searching)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_41, "COTIZAR AHORA"))
                  : _createCommentVNode("", true),
                (_ctx.flags.searching)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_42))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_40)
            ]),
            _hoisted_43
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_link, {
      to: { name: 'tyc' },
      target: "_blank"
    }, {
      default: _withCtx(() => [
        _hoisted_44
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("div", _hoisted_46, [
        _hoisted_47,
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("img", {
                      src: require('@/assets/images/app/check-green.png'),
                      alt: ""
                    }, null, 8, _hoisted_55)
                  ]),
                  _hoisted_56
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("img", {
                      src: require('@/assets/images/app/check-green.png'),
                      alt: ""
                    }, null, 8, _hoisted_60)
                  ]),
                  _hoisted_61
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("img", {
                      src: require('@/assets/images/app/check-green.png'),
                      alt: ""
                    }, null, 8, _hoisted_66)
                  ]),
                  _hoisted_67
                ])
              ])
            ]),
            _hoisted_68,
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("img", {
                src: require('@/assets/images/app/shield-user.png'),
                alt: ""
              }, null, 8, _hoisted_70),
              _hoisted_71
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_72, [
      _createElementVNode("div", _hoisted_73, [
        _hoisted_74,
        _createElementVNode("div", _hoisted_75, [
          _createElementVNode("img", {
            src: require('@/assets/images/app/Story-desktop.png'),
            alt: ""
          }, null, 8, _hoisted_76),
          _createElementVNode("img", {
            src: require('@/assets/images/app/Story-mobile.png'),
            alt: ""
          }, null, 8, _hoisted_77)
        ]),
        _createElementVNode("a", {
          href: _ctx.pdfPath,
          target: "_blank"
        }, [
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("img", {
                  class: "custom-cintillo__cintillo custom-cintillo--desktop",
                  src: require('@/assets/images/app/folleto/folleto_desktop.png'),
                  alt: "folleto"
                }, null, 8, _hoisted_82),
                _createElementVNode("img", {
                  class: "custom-cintillo__cintillo custom-cintillo--mobile",
                  src: require('@/assets/images/app/folleto/folleto_mobile.png'),
                  alt: "folleto"
                }, null, 8, _hoisted_83)
              ])
            ])
          ])
        ], 8, _hoisted_78),
        _hoisted_84
      ])
    ]),
    _createElementVNode("div", _hoisted_86, [
      _createElementVNode("div", _hoisted_87, [
        _hoisted_88,
        _createElementVNode("div", _hoisted_89, [
          _createElementVNode("div", _hoisted_90, [
            _createElementVNode("ul", _hoisted_91, [
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("img", {
                    src: require('@/assets/images/app/paso-1.png'),
                    alt: ""
                  }, null, 8, _hoisted_93)
                ]),
                _hoisted_94
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("img", {
                    src: require('@/assets/images/app/paso-2.png'),
                    alt: ""
                  }, null, 8, _hoisted_96)
                ]),
                _hoisted_97
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_98, [
                  _createElementVNode("img", {
                    src: require('@/assets/images/app/paso-3.png'),
                    alt: ""
                  }, null, 8, _hoisted_99)
                ]),
                _hoisted_100
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_101, [
                  _createElementVNode("img", {
                    src: require('@/assets/images/app/paso-4.png'),
                    alt: ""
                  }, null, 8, _hoisted_102)
                ]),
                _hoisted_103
              ])
            ]),
            _hoisted_104
          ]),
          _createElementVNode("div", _hoisted_105, [
            _createElementVNode("div", _hoisted_106, [
              _createElementVNode("img", {
                src: require('@/assets/images/app/gif-28-02.gif'),
                alt: ""
              }, null, 8, _hoisted_107)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_108, [
      _createElementVNode("a", _hoisted_109, [
        _createElementVNode("div", _hoisted_110, [
          _createElementVNode("img", {
            src: require('@/assets/images/app/vivemas.svg'),
            alt: "vivemas",
            width: "100%"
          }, null, 8, _hoisted_111)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_112, [
      _createElementVNode("a", _hoisted_113, [
        _createElementVNode("div", _hoisted_114, [
          _createElementVNode("img", {
            src: require('@/assets/images/app/vivemas_mobile.svg'),
            alt: "vivemas"
          }, null, 8, _hoisted_115)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_116, [
      _createElementVNode("div", _hoisted_117, [
        _hoisted_118,
        (_ctx.carouselItems > 0)
          ? (_openBlock(), _createBlock(_component_carousel, {
              key: 0,
              margin: 0,
              dots: true,
              nav: false,
              items: _ctx.carouselItems,
              loop: true,
              autoplay: true,
              "autoplay-timeout": 2000
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_119, [
                  _createElementVNode("div", _hoisted_120, [
                    _createElementVNode("img", {
                      src: require('@/assets/images/app/c-1.png'),
                      loading: "lazy",
                      alt: ""
                    }, null, 8, _hoisted_121)
                  ]),
                  _hoisted_122,
                  _hoisted_123
                ]),
                _createElementVNode("div", _hoisted_124, [
                  _createElementVNode("div", _hoisted_125, [
                    _createElementVNode("img", {
                      src: require('@/assets/images/app/c-2.png'),
                      loading: "lazy",
                      alt: ""
                    }, null, 8, _hoisted_126)
                  ]),
                  _hoisted_127,
                  _hoisted_128
                ]),
                _createElementVNode("div", _hoisted_129, [
                  _createElementVNode("div", _hoisted_130, [
                    _createElementVNode("img", {
                      src: require('@/assets/images/app/c-3.png'),
                      loading: "lazy",
                      alt: ""
                    }, null, 8, _hoisted_131)
                  ]),
                  _hoisted_132,
                  _hoisted_133
                ])
              ]),
              _: 1
            }, 8, ["items"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_134, [
      _hoisted_135,
      _createElementVNode("div", _hoisted_136, [
        _createElementVNode("div", _hoisted_137, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faq, (f) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["home__section-faq__card", { open: f.show }]),
              key: 'faq-' + f.id
            }, [
              _createElementVNode("span", {
                onClick: ($event: any) => (f.show = !f.show)
              }, _toDisplayString(f.question), 9, _hoisted_138),
              _withDirectives(_createElementVNode("p", null, _toDisplayString(f.answer), 513), [
                [_vShow, f.show]
              ])
            ], 2))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_139, [
      _createElementVNode("div", _hoisted_140, [
        _createElementVNode("form", {
          action: "#",
          onSubmit: _cache[10] || (_cache[10] = ($event: any) => (_ctx.saveLead($event)))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", { invalid: this.v$.lead.email.$error }])
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "Ingresa tu correo electronico",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((this.v$.lead.email.$model) = $event))
            }, null, 512), [
              [_vModelText, this.v$.lead.email.$model]
            ]),
            _createElementVNode("button", {
              type: "submit",
              class: "form-btn",
              disabled: _ctx.flags.savingLead
            }, [
              (!_ctx.flags.savingLead)
                ? (_openBlock(), _createElementBlock("span", _hoisted_142, "¡Quiero más información!"))
                : _createCommentVNode("", true),
              (_ctx.flags.savingLead)
                ? (_openBlock(), _createElementBlock("i", _hoisted_143))
                : _createCommentVNode("", true)
            ], 8, _hoisted_141)
          ], 2)
        ], 32),
        (_ctx.flags.savedLead)
          ? (_openBlock(), _createElementBlock("div", _hoisted_144, _hoisted_146))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("a", {
      class: "imagen-button folleto hidden-mobile",
      id: "chatButton",
      target: "_blank",
      href: _ctx.pdfPath
    }, [
      _createElementVNode("img", {
        src: require('@/assets/images/app/folleto/flotante_desktop.png'),
        alt: "",
        width: "180",
        loading: "lazy"
      }, null, 8, _hoisted_148)
    ], 8, _hoisted_147),
    _createElementVNode("a", {
      class: "imagen-button folleto visible-mobile",
      id: "chatButton",
      target: "_blank",
      href: _ctx.pdfPath
    }, [
      _createElementVNode("img", {
        src: require('@/assets/images/app/folleto/flotante_mobile.png'),
        alt: "",
        width: "180",
        loading: "lazy"
      }, null, 8, _hoisted_150)
    ], 8, _hoisted_149),
    _createElementVNode("a", {
      class: "chat-button phone",
      id: "chatButton",
      target: "_blank",
      href: "tel:016149288999",
      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openWapp()))
    }, [
      _createElementVNode("img", {
        src: require('@/assets/images/app/newWpp.png'),
        alt: "",
        width: "160",
        loading: "lazy"
      }, null, 8, _hoisted_151),
      _hoisted_152,
      _hoisted_153
    ]),
    _createElementVNode("a", {
      class: "chat-button hidden-mobile",
      id: "chatButton",
      target: "_blank",
      href: "https://api.whatsapp.com/send?phone=51946523076&text=Hola%2C%20Rumbo.%20%C2%A1Deseo%20m%C3%A1s%20informaci%C3%B3n!",
      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openWapp()))
    }, [
      _createElementVNode("img", {
        src: require('@/assets/images/app/wapp-chat.svg'),
        alt: "",
        width: "160",
        loading: "lazy"
      }, null, 8, _hoisted_154),
      _hoisted_155
    ]),
    _createElementVNode("div", _hoisted_156, [
      _createElementVNode("div", _hoisted_157, [
        _createElementVNode("div", _hoisted_158, [
          _hoisted_159,
          _createElementVNode("div", _hoisted_160, [
            _createElementVNode("div", _hoisted_161, [
              _createElementVNode("div", _hoisted_162, [
                _createElementVNode("img", {
                  src: require('@/assets/images/app/is-white.png'),
                  alt: ""
                }, null, 8, _hoisted_163)
              ])
            ])
          ])
        ])
      ]),
      _hoisted_164,
      _createElementVNode("div", _hoisted_165, [
        _createElementVNode("div", _hoisted_166, [
          _createElementVNode("div", _hoisted_167, [
            _createElementVNode("div", _hoisted_168, [
              _createVNode(_component_router_link, {
                to: { name: 'tyc' },
                target: "_blank",
                class: "col-xs-12 col-sm-12 col-md-6"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Promociones ")
                ]),
                _: 1
              }),
              _hoisted_169,
              _hoisted_170,
              _hoisted_171
            ])
          ]),
          _createElementVNode("div", _hoisted_172, [
            _createElementVNode("div", _hoisted_173, [
              _createElementVNode("div", _hoisted_174, [
                _createElementVNode("a", _hoisted_175, [
                  _createElementVNode("img", {
                    class: "libro",
                    src: require('@/assets/images/app/libro_ant.svg'),
                    alt: ""
                  }, null, 8, _hoisted_176)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_177, [
              _createElementVNode("div", _hoisted_178, [
                _createElementVNode("a", _hoisted_179, [
                  _createElementVNode("img", {
                    class: "libro",
                    src: require('@/assets/images/app/libro_ant2.svg'),
                    alt: ""
                  }, null, 8, _hoisted_180)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_b_modal, {
      id: "login-modal",
      "ok-only": "",
      centered: "",
      size: "sm",
      "modal-class": "login-modal",
      title: "Zona Cliente",
      ref: "login-modal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_181, [
          (!_ctx.flags.validateOtp)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                action: "#",
                onSubmit: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.sendOtp && _ctx.sendOtp(...args)))
              }, [
                _createElementVNode("div", _hoisted_182, [
                  _createElementVNode("div", _hoisted_183, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: "client-dni",
                      name: "client-doc",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((this.v$.login.identificationType.$model) = $event)),
                      value: "dni",
                      onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.setDocumentLength())),
                      checked: ""
                    }, null, 544), [
                      [_vModelRadio, this.v$.login.identificationType.$model]
                    ]),
                    _hoisted_184
                  ]),
                  _createElementVNode("div", _hoisted_185, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "client-doc",
                      id: "client-ce",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((this.v$.login.identificationType.$model) = $event)),
                      value: "ce",
                      onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.setDocumentLength()))
                    }, null, 544), [
                      [_vModelRadio, this.v$.login.identificationType.$model]
                    ]),
                    _hoisted_186
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-group d-block", { invalid: this.v$.login.identificationNumber.$error }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "Digita tu número de documento",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((this.v$.login.identificationNumber.$model) = $event)),
                    onKeypress: _cache[18] || (_cache[18] = ($event: any) => (_ctx.validateInput($event)))
                  }, null, 544), [
                    [_vModelText, this.v$.login.identificationNumber.$model]
                  ]),
                  (this.v$.login.identificationNumber.$error && _ctx.flags.showError
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
                        _createElementVNode("span", {
                          class: _normalizeClass({ error: this.v$.login.identificationNumber.$error })
                        }, "Ingrese un número de documento válido", 2)
                      ]))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", _hoisted_188, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "form-btn",
                    disabled: _ctx.flags.logingIn
                  }, [
                    (!_ctx.flags.logingIn)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_190, "Continuar"))
                      : _createCommentVNode("", true),
                    (_ctx.flags.logingIn)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_191))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_189)
                ])
              ], 32))
            : _createCommentVNode("", true),
          (_ctx.flags.validateOtp)
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                action: "#",
                onSubmit: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.validateOtp && _ctx.validateOtp(...args)))
              }, [
                _createElementVNode("div", _hoisted_192, [
                  _createElementVNode("label", _hoisted_193, "Ingresa el código enviado al correo " + _toDisplayString(_ctx.otp.email), 1)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-group d-block", { invalid: this.v$.login.identificationNumber.$error }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "Codigo de autenticación",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((this.v$.otpCode.code.$model) = $event))
                  }, null, 512), [
                    [_vModelText, this.v$.otpCode.code.$model]
                  ]),
                  (this.v$.userInfo.identificationNumber.$error && _ctx.flags.showError
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_194, [
                        _createElementVNode("span", {
                          class: _normalizeClass({ error: this.v$.login.identificationNumber.$error })
                        }, "Ingrese un código válido", 2)
                      ]))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", _hoisted_195, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "form-btn",
                    disabled: _ctx.flags.logingIn
                  }, [
                    (!_ctx.flags.logingIn)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_197, "Validar"))
                      : _createCommentVNode("", true),
                    (_ctx.flags.logingIn)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_198))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_196)
                ])
              ], 32))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-no-insurance",
      "ok-only": "",
      "ok-title": "Entiendo",
      centered: "",
      "modal-class": "modal-no-insurance",
      ref: "modal-no-insurance"
    }, {
      default: _withCtx(() => [
        _hoisted_199,
        _createElementVNode("div", _hoisted_200, [
          _createElementVNode("button", {
            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.closeModalNoInsurance()))
          }, "Aceptar")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-cookies",
      "ok-only": "",
      "ok-title": "",
      centered: "",
      "modal-class": "cookies",
      ref: "modal-cookies"
    }, {
      default: _withCtx(() => [
        _hoisted_201,
        _createElementVNode("div", _hoisted_202, [
          _createElementVNode("div", _hoisted_203, [
            _createElementVNode("div", _hoisted_204, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.acceptBasicCookies && _ctx.acceptBasicCookies(...args)))
              }, " Solo cookies funcionales ")
            ]),
            _createElementVNode("div", _hoisted_205, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.acceptAllCookies && _ctx.acceptAllCookies(...args)))
              }, " Todas las cookies ")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_206, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_207, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.acceptBasicCookies && _ctx.acceptBasicCookies(...args)))
              }, " Solo cookies funcionales ")
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_208, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.acceptAllCookies && _ctx.acceptAllCookies(...args)))
              }, " Todas las cookies ")
            ])
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "comunications-policies-modal",
      "ok-only": "",
      "ok-title": "Entendido",
      centered: "",
      size: "lg",
      "modal-class": "modal-conditions",
      title: "Política de Comunicaciones",
      ref: "comunications-policies-modal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_card_text, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_209, [
              _hoisted_210,
              _createElementVNode("div", _hoisted_211, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "custom-control-input",
                  id: "chkbxPolicies1",
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.comunicationPolicies.profile) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.comunicationPolicies.profile]
                ]),
                _hoisted_212
              ]),
              _createElementVNode("div", _hoisted_213, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "custom-control-input",
                  id: "chkbxPolicies2",
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.comunicationPolicies.offers) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.comunicationPolicies.offers]
                ]),
                _hoisted_214
              ]),
              _createElementVNode("div", _hoisted_215, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "custom-control-input",
                  id: "chkbxPolicies3",
                  checked: _ctx.comunicationPolicies.profile && _ctx.comunicationPolicies.offers
              ,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.comunicationPolicies.all) = $event)),
                  onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.changeComunicationPolicyContiion()))
                }, null, 40, _hoisted_216), [
                  [_vModelCheckbox, _ctx.comunicationPolicies.all]
                ]),
                _hoisted_217
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512)
  ]))
}